module.exports = __webpack_public_path__ + "fonts/LINESeedSans_A_XBd.c1c2286e.otf";